import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import { theme, Tooltip } from 'antd';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

const BatchCompliance = ({ concreteBatch }) => {
  const intl = useIntl();
  const { token } = theme.useToken();

  return (
    <>
      {concreteBatch?.batch_compliance && (
        <CheckCircleFilled style={{ color: token.colorSuccess, size: 24 }} />
      )}
      {!concreteBatch?.batch_volume_compliance &&
      !concreteBatch?.batch_time_compliance ? (
        <Tooltip
          placement="right"
          title={`${intl.formatMessage({
            id: 'batch_compliance.volume',
          })} / ${intl.formatMessage({ id: 'batch_compliance.time' })}`}
        >
          <CloseCircleFilled style={{ color: token.colorError, size: 24 }} />
        </Tooltip>
      ) : (
        <>
          {!concreteBatch?.batch_time_compliance && (
            <Tooltip
              placement="right"
              title={intl.formatMessage({ id: 'batch_compliance.time' })}
            >
              <CloseCircleFilled
                style={{ color: token.colorError, size: 24 }}
              />
            </Tooltip>
          )}
          {!concreteBatch?.batch_volume_compliance && (
            <Tooltip
              placement="right"
              title={intl.formatMessage({ id: 'batch_compliance.volume' })}
            >
              <CloseCircleFilled
                style={{ color: token.colorError, size: 24 }}
              />
            </Tooltip>
          )}
        </>
      )}
    </>
  );
};
BatchCompliance.propTypes = {
  concreteBatch: PropTypes.shape({
    batch_compliance: PropTypes.bool,
    batch_volume_compliance: PropTypes.bool,
    batch_time_compliance: PropTypes.bool,
  }).isRequired,
};

export default BatchCompliance;
